import Box from '@mui/material/Box';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export const FullScreenModalContainer: React.FC<React.PropsWithChildren> = (
  props: React.PropsWithChildren,
): React.ReactElement => {
  const { children } = props;

  return <Box sx={styles.sectionsContainer}>{children}</Box>;
};

const styles: Record<string, SystemStyleObject> = {
  sectionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: 5,
    bgcolor: 'custom.AlternativeBackground',
    gap: 3,
  },
};
